import { newE2EPage } from '@stencil/core/testing';

describe('pnk-table', () => {
  it('renders', async () => {
    const page = await newE2EPage();

    await page.setContent('<pnk-table></pnk-table>');
    const element = await page.find('pnk-table');
    expect(element).toHaveClass('hydrated');
  });
});
